import { createSlice } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/service/Service";

export const userLoginSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    userLogin: builder.mutation({
        query: (body) => ({
          url: `Account/LoginUser`,
          method: "POST",
          body,
        }),
      }),

      // userExistance: builder.mutation({
      //   query: (body) => ({
      //     url: `Account/UserExistance`,
      //     method: "POST",
      //     body,
      //   }),
      // }),


    })
})

export const { useUserLoginMutation } = apiSlice;

